import React, { useEffect, useState } from 'react';
import { connect, history } from 'umi';

import { get, head } from 'lodash';
import useResponsive from '@/hooks/useResponsive';
import { setLocalStorageWithPath, getAppInfo } from '@/utils/utilsPoint';
// import { trackSensors } from '@/utils/appsensors';
import { PartnerMerchantsDetails } from './components';

const OfferDetails = props => {
  // const entrancePage = get(props, 'location.state.entrancePage');
  const { getProductDetailDXP, getPointDetailDXP } = props;
  const str = window.location.pathname.split('/');
  const targetStr = str[str.length - 1];
  // const [urlId] = [params.get('id')];
  // const spuId = Number(targetStr);
  const spuId = targetStr;

  // const spuId = get(props, 'location.state.skuId') || get(props, 'location.state.productListitem.id') || Number(targetStr);
  const [productListitem, setProductListitem] = useState({});
  const [skuListItem, setskuItem] = useState(null);
  const [userInfo, setuserInfo] = useState({});
  const { pointAcctTypeCode, category } = history.location.query;
  // 响应式 hook
  useResponsive();

  useEffect(() => {
    setLocalStorageWithPath('email', null);
    getAppInfo(getuserInfo => {
      setuserInfo(getuserInfo);
      getPointDetailDXP({
        scopes: 'LATEST_EXPIRING_POINT',
      });
      getProductDetailDXP({
        spuNbr: spuId,
        pointAcctTypeCode,
      }).then(shopProdres => {
        const offerItem = get(shopProdres, 'shopProdDetail') || {};
        setProductListitem(offerItem);
        setskuItem(head(get(offerItem, 'skuList')) || {});
      });
    });
  }, []);

  // const selectSku = skuListItems => {
  //   setskuItem(skuListItems);
  // };

  return (
    // <div>
    <PartnerMerchantsDetails
      productListitem={productListitem}
      skuListItem={skuListItem}
      // cityDtoList={cityDtoList}
      userInfo={userInfo}
      pointAcctTypeCode={pointAcctTypeCode}
      category={category}
    />
    // </div>
  );
};

const mapDispatchToProps = dispatch => ({
  getPointDetailDXP: payload =>
    dispatch({
      type: 'pointShop/getPointDetailDXP',
      payload,
    }),
  getProductDetailDXP: payload =>
    dispatch({
      type: 'pointShop/getProductDetailDXP',
      payload,
    }),
  getConfigParamDXP: payload =>
    dispatch({
      type: 'index/getConfigParamDXP',
      payload,
    }),
});

export default connect(
  ({ pointShop }) => ({
    pointDetail: pointShop.pointDetail,
  }),
  mapDispatchToProps,
)(OfferDetails);
